export { ImageMural } from './image-mural';
